var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-principal",class:_vm.componenteAtual},[_c('div',{staticStyle:{"width":"100%"}},[_c(_vm.componenteAtual,{tag:"component",attrs:{"dados":_vm.dados},on:{"dados-etapa":_vm.handleDadosEtapa,"proxima-etapa":_vm.proximo,"etapa-anterior":_vm.anterior}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }